export const SKILLS_OPTIONS = [
  { value: 'plumbing', label: 'Plumbing' },
  { value: 'electrical', label: 'Electrical' },
  { value: 'carpentry', label: 'Carpentry' },
  { value: 'painting', label: 'Painting' },
  { value: 'hvac', label: 'HVAC (Heating & Cooling)' },
  { value: 'appliance_repair', label: 'Appliance Repair' },
  { value: 'flooring', label: 'Flooring Installation' },
  { value: 'roofing', label: 'Roofing' },
  { value: 'gardening', label: 'Gardening & Landscaping' },
  { value: 'cleaning', label: 'Cleaning Services' },
  { value: 'pest_control', label: 'Pest Control' },
  { value: 'handyman', label: 'General Handyman' },
  { value: 'locksmith', label: 'Locksmith' },
  { value: 'masonry', label: 'Masonry & Brickwork' },
  { value: 'drywall', label: 'Drywall & Insulation' },
  { value: 'windows_doors', label: 'Windows & Doors' }
];
